<template>
  <div class="subheader-nav-item clickable"
       v-bind:class="{ 'subheader-nav-item--active': isActive }"
       v-on:click="$emit('click')">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'subheader-nav-item',

    props: {
      isActive: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style lang="scss">
  .subheader-nav-item {
    display: inline-block;
    border-bottom: 2px solid transparent;
    min-width: 89px;
    padding-top: 8px;
    padding-bottom: 6px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
    line-height: 1.29;
    text-align: center;

    &.subheader-nav-item--active {
      border-bottom-color: #00c896;
      color: #00c896;
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// SubheaderNavItem.vue?3b9269cd